import React from 'react';

let id = 0; // consider using uuidv4

const useUniqueKey = (name: string): string => {
    const [uniqueId] = React.useState(() => {
        id = (id + 1) % Number.MAX_SAFE_INTEGER;
        return id;
    });
    return `${name}-${uniqueId}`;
};

export { useUniqueKey };
